<template>
  <div class="case-video">
    <div class="video-thumbnail">
      <img v-bind="$attrs" :src="src">
      <div class="play-icon">
        <icon-play />
      </div>
    </div>

    <div class="video-meta">
      <div class="video-title">{{ title }}</div>
      <div class="video-city">{{ subtitle }}</div>
    </div>
</div>
</template>

<script>
import iconPlay from '@icons/icon-play'

export default {
  inheritAttrs: false,
  components: { iconPlay },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';
@import '~@helpers/no-drag';

.case-video {
  flex: 0 0 calc(100% / 3 - calc(#{$global-padding} * 2));

  @at-root .internet-explorer #{&} {
    max-width: 345px;
  }

  margin: 20px;

  cursor: pointer;

  transition: all $duration-normal $easeing-OutExpo;

  @media #{$below-breakpoint-1024} {
    flex: 0 0 calc(100% / 2 - calc(#{$global-padding} * 2));
    margin: 20px;

    @at-root .internet-explorer #{&} {
      max-width: calc(50% - 50px);
    }
  }

  @media #{$below-breakpoint-768} {
    flex: 0 0 100%;

    @at-root .internet-explorer #{&} {
      width: 100%;
      max-width: calc(100% - 40px);
    }
  }

  @media only screen and (min-device-width : 768px)  and (max-device-width : 1024px)  {
    flex: 0 0 calc(100% / 2 - calc(#{$global-padding} * 2));
  }

  &:hover {
    @media (pointer: fine) {
      box-shadow: 3px 3px 20px rgba($color-black, .2);

      .video-title {
        color: $color-red;
      }

      .play-icon {
        transform: scale(1.03);
        box-shadow: 2px 5px 20px rgba($color-black, .3);
      }
    }
  }

  .video-thumbnail {
    height: 210px;

    position: relative;

    img {
      @include object-fit(cover, center);
      @extend .no-drag;
    }
  }

  .play-icon {
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    right: 25px;
    bottom: 25px;

    height: 44px;
    width: 44px;

    border-radius: 50%;

    background: $color-red;
    color: white;

    transition: all $duration-normal $easeing-OutExpo;

    svg {
      transform: scale(0.4) translateX(2px);
    }
  }

  .video-meta {
    background-color: $color-grey-x;
    height: 200px;
    padding: calc(#{$global-padding} * 1.25);

    position: relative;

    @media #{$below-breakpoint-1024} {
      height: auto;
      padding-bottom: calc(#{$global-padding} * 3);
    }
  }

  .video-title {
    @include font-size(24px, 30px);
    font-weight: 700;
    width: 100%;

    transition: color $duration-normal $easeing-OutExpo;
  }

  .video-city {
    @include font-size(14px, 16px);
    color: $color-red;

    position: absolute;
    bottom: calc(#{$global-padding} * 1.25);
    left: calc(#{$global-padding} * 1.25);
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/case-video.vue